import {
    INTENT_REQUEST_DATA,
    DENOMINATIONS_LIST,
    BANKS_BRANCHES_LIST,
    BANKS_LIST,
    OFFICERS_LIST,
    INTENT_POST_START,
    INTENT_POST_RESPONSE,
    INTENT_INITIAL_FORM_DATA,
    INTENT_DENOMINATIONS_FORM_DATA,
    INTENT_OFFICERS_FORM_DATA,
    ON_INTENT_SUBMIT_ERRORS,
    CENTERS_LIST,
    INTENT_INIT,
    LOAD_INTENTS,
    LOAD_INTENT_SINGLE_START,
    LOAD_INTENT_SINGLE_DONE,
    SINGLE_INTENT_DATA,
    INTENT_FILE_FETCH_START,
    INTENT_FILE_FETCH_DONE,
    INTENT_FILE_FETCH_ERROR,
    INTENT_FILE,
    RESET_INTENT_FILE
} from '../constants/ActionTypes';

const user = JSON.parse(sessionStorage.getItem('user'));

const INIT_STATE = {
    loading: true,
    posting: false,
    singleLoading: false,
    denominationsList: [],
    banksList: [],
    centersList: [],
    banksBranchesList: [],
    officersList: [],
    intentData: [],
    intentPostData: null,
    intentInitialForm: {
        intentType: 1,
        custodyCenterId: (user !== null) ? user.SCC_ID : null,
        currency: 1,
        transDate: new Date(),
        letterDate: new Date(),
        letterReceiveDate: new Date()
    },
    intentDenominationsForm: [],
    intentOfficersForm: {},
    intentSubmitErrors: [],
    intentPutResponse: {},
    intentSingle: null,
    intentFile: {
        status: 'idle',
        data: null,
        error: null
    }
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOAD_INTENTS: {
            return {
                ...state,
                loading: true
            }
        }
        case BANKS_LIST: {
            return {
                ...state,
                banksList: action.payload
            }
        }
        case CENTERS_LIST: {
            return {
                ...state,
                centersList: action.payload
            }
        }
        case BANKS_BRANCHES_LIST: {
            return {
                ...state,
                banksBranchesList: action.payload
            }
        }

        case DENOMINATIONS_LIST: {
            return {
                ...state,
                denominationsList: action.payload
            }
        }
        case OFFICERS_LIST: {
            return {
                ...state,
                officersList: action.payload
            }
        }
        case INTENT_REQUEST_DATA: {
            return {
                ...state,
                loading: false,
                intentData: action.payload
            }
        }

        case LOAD_INTENT_SINGLE_START: {
            return {
                ...state,
                singleLoading: true
            }
        }

        case LOAD_INTENT_SINGLE_DONE: {
            return {
                ...state,
                singleLoading: false
            }
        }

        case SINGLE_INTENT_DATA: {
            return {
                ...state,
                singleLoading: false,
                intentSingle: action.payload
            }
        }

        case INTENT_POST_START: {
            return {
                ...state,
                posting: true
            }
        }
        case INTENT_POST_RESPONSE: {
            return {
                ...state,
                posting: false,
                intentPostData: action.payload
            }
        }

        case INTENT_INITIAL_FORM_DATA: {
            return {
                ...state,
                intentInitialForm: action.payload
            }
        }

        case INTENT_DENOMINATIONS_FORM_DATA: {
            return {
                ...state,
                intentDenominationsForm: action.payload
            }
        }
        case INTENT_OFFICERS_FORM_DATA: {
            return {
                ...state,
                intentOfficersForm: action.payload
            }
        }
        case ON_INTENT_SUBMIT_ERRORS: {
            return {
                ...state,
                intentSubmitErrors: [action.payload]
            }
        }
        case INTENT_INIT: {
            return state = INIT_STATE
        }
        case INTENT_FILE_FETCH_START: {
            return {
                ...state,
                intentFile: {
                    ...state['intentFile'], status: 'loading'
                }
            }
        }
        case INTENT_FILE_FETCH_DONE: {
            return {
                ...state,
                intentFile: {
                    ...state['intentFile'], status: 'idle'
                }
            }
        }
        case INTENT_FILE_FETCH_ERROR: {
            return {
                ...state,
                intentFile: {
                    ...state['intentFile'], error: action.payload
                }
            }
        }
        case INTENT_FILE: {
            return {
                ...state,
                intentFile: {
                    ...state['intentFile'], data: action.payload
                }
            }
        }
        case RESET_INTENT_FILE: {
            return {
                ...state,
                intentFile: {
                    ...state['intentFile'], data: null, error: null
                }
            }
        }

        default:
            return state;
    }
}